import { toast } from 'react-hot-toast';
// Some callers pass raw error objects (e.g. axios `{msg}` or Error) instead of a string.
// Rendering a non-string as a toast child crashes react-hot-toast ("Objects are not valid
// as a React child"), so coerce everything to a safe string here.
const toMessage = (message) => {
    if (typeof message === 'string')
        return message;
    if (message && typeof message === 'object') {
        const value = message;
        if (typeof value.msg === 'string')
            return value.msg;
        if (typeof value.message === 'string')
            return value.message;
    }
    return 'Something went wrong';
};
export class ToastService {
    static success(message) {
        toast.success(toMessage(message));
    }
    static error(message) {
        toast.error(toMessage(message));
    }
}
